import React, { useState } from "react";
import "./organizationContent.css";
import FaSpinner from "../../faSpinner/faSpinner";
import Heading from "../../heading/heading";
import { getRouteUrl } from "../../../routers";
import ApplicationListItem from "../../applicationListItem/applicationListItem";
import FileTable from "../../fileTable/fileTable";
import UploadDocumentsForm from "../uploadDocumentsForm/uploadDocumentsForm";
import UploadFileErrors from "../uploadFileErrors/uploadFileErrors";
import Button from "../../button/button";
import { ROUTE_APPLICATION_CREATE } from "../../../routers/content/application";
import SimpleButtonWrapper from "../../simpleButtonWrapper/simpleButtonWrapper";
import { Link } from "react-router-dom";
import {
  DEVELOPER,
  LEGAL,
  ORGANIZATION_OWNER,
} from "../../../constants/organizationRoles";
import { useOrganization } from "../OrganizationProvider";
import OrganizationPermission from "../organizationPermission/OrganizationPermission";
import useUser from "../../../customHooks/useUser";

const DOCUMENT_ROLES = [ORGANIZATION_OWNER, DEVELOPER, LEGAL];

const OrganizationContent = () => {
  const [files, setFiles] = useState(undefined);
  const user = useUser();
  const {
    organizationData,
    organizationContentData,
    loading,
    uploadOrganizationFile,
    updateOrganization,
    documents,
    organizationMembers,
    deleteOrganizationDocument,
  } = useOrganization();
  const { uuid } = organizationData;

  const userRoles = () => {
    if (!organizationMembers || !user) return [];
    const userMembership = organizationMembers.find(
      (m) => m.uuid === user.uuid
    );
    return userMembership?.roles || [];
  };
  const isOwnerMember = () => userRoles().includes(ORGANIZATION_OWNER);
  // Owner, Developer and Legal may see and add documents (the Core accepts documents-only
  // updates from Developer/Legal); removing a document stays an Owner action.
  const canManageDocuments = () =>
    userRoles().some((r) => DOCUMENT_ROLES.includes(r));

  return (
    <div>
      <div className="nbg-organization-wrapper">
        <div className="clearfix">
          <div className="clearfix">
            {organizationContentData && (
              <Heading level={3} style={{ display: "inline-block" }}>
                Applications
              </Heading>
            )}
            <OrganizationPermission
              allowedRoles={[DEVELOPER, ORGANIZATION_OWNER]}
            >
              <SimpleButtonWrapper position="right">
                <Link
                  to={getRouteUrl(ROUTE_APPLICATION_CREATE, null, {
                    organization: uuid,
                  })}
                >
                  <Button className="add_application_button" electro>
                    ADD AN APPLICATION
                  </Button>
                </Link>
              </SimpleButtonWrapper>
            </OrganizationPermission>
          </div>
          <div>
            {organizationContentData &&
              organizationContentData.map((application) => (
                <ApplicationListItem
                  organizationUuid={uuid}
                  application={application}
                  key={application.uuid}
                />
              ))}
          </div>
        </div>
        <br />
        {documents && canManageDocuments() && (
          <div>
            <Heading level={3}>
              Documents
              <OrganizationPermission allowedRoles={DOCUMENT_ROLES}>
                <UploadDocumentsForm
                  files={files}
                  loading={uploadOrganizationFile.isLoading}
                  onSubmit={(evt) => {
                    setFiles(undefined);
                    evt.preventDefault();
                    if (files) {
                      uploadOrganizationFile.mutate({
                        documents: files,
                        organizationId: uuid,
                        field_documents: documents.map((doc) => doc.uuid),
                      });
                    }
                  }}
                  onFileChange={(evt) => {
                    if (evt.target.files && evt.target.files.length > 0) {
                      setFiles(evt.target.files);
                    }
                  }}
                />
              </OrganizationPermission>
            </Heading>
            <UploadFileErrors organizationId={uuid} />
            <FileTable
              rowProps={{
                onRemove: isOwnerMember()
                  ? (docId) => {
                      setFiles(undefined);
                      deleteOrganizationDocument.mutate(docId);
                    }
                  : undefined,
              }}
              files={documents}
              loading={loading}
            />

            <p
              style={{
                marginTop: 25,
                color: "red",
              }}
            >
              {uploadOrganizationFile?.error?.message}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrganizationContent;
